import React from "react";
import { AppBar, Toolbar, Button } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import imgLogo from "../../assets/images/logo-link-blanco.png";
import { auth } from "../../firebase";

const useStyles = makeStyles((theme) => ({
  img: {
    margin: `10px ${theme.spacing(2)}`,
    width: "30%",
    [theme.breakpoints.up("sm")]: {
      width: "20%",
    },
    [theme.breakpoints.up("md")]: {
      width: "12%",
    },
  },
}));

const logout = () => {
  auth
    .signOut()
    .then(function () {})
    .catch(function (error) {});
};

function TopBar() {
  const classes = useStyles();
  return (
    <AppBar position="relative">
      <Toolbar style={{ display: "flex", justifycontent: "space-between" }}>
        <a href="https://trabajaconlinkmys.firebaseapp.com/">
          {" "}
          <img
            src={imgLogo}
            style={{ margin: "10px 0" }}
            className={classes.img}
            alt="Logo"
          ></img>
        </a>
        <Button type="submit" variant="contained" onClick={() => logout(true)}>
          <b>Salir</b>
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
